// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"8992051f","219":"5c857d8c","363":"3f97228e","522":"5365087b","787":"f5bd230d","864":"d30e358d"}[chunkId] + ".chunk.js";
};